export const PASSWORD_FORM_FIELD_TYPE = 'password';
export const TEXT_FORM_FIELD_TYPE = 'text';

export const NEW_PASSWORD_FORM_FIELD_NAME = 'newPassword';
export const CONFIRM_PASSWORD_FORM_FIELD_NAME = 'confirmPassword';

export const INVALID_TOKEN_HEADER_ERROR_VALUE = "InvalidTokenHeader";

export const BLANK_SPACE = '\u00A0';


// WEBPACK FOOTER //
// ./src/features/login/constants/resetPasswordConstants.js